import CustomEvent from "./customEvent";

export const dispatch = (eventType, values = {}) => {
    const event = new CustomEvent(eventType, values);
    window.dispatchEvent(event);
}


export const eventListener = (eventType, callBack) => {
    window.addEventListener(eventType, callBack, { passive: true });
}

export const removeEventListener = (eventType, callBack) => {
    window.removeEventListener(eventType, callBack);
}
